/*
 * Bello — Reveal on scroll
 *
 * Deals the children of any [data-bello-reveal] list into view, staggered.
 * Paired with bello-reveal.css. See that file for the tuning properties.
 *
 * Four of the drink-capsules sections each load this asset, so the file is
 * guarded: the work runs once no matter how many <script> tags point here.
 */
(function () {
  'use strict';

  if (window.__belloReveal) return;
  window.__belloReveal = true;

  var ARMED = 'bello-reveal-armed';
  var IN = 'bello-reveal-in';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /*
   * Strips every trace of the reveal once the last card has settled. The armed
   * rule sets `transition` on each card, which would otherwise replace whatever
   * transition that card already had of its own — the FAQ item, for one,
   * animates its border colour when it opens. Cleaning up hands each section
   * its own styles back, and the cards are already at their final values, so
   * nothing moves.
   */
  function disarm(list) {
    list.classList.remove(ARMED);
    var cards = list.children;
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove(IN);
      cards[i].style.removeProperty('--bello-reveal-index');
      cards[i].style.removeProperty('opacity');
      delete cards[i].__belloRestingOpacity;
      if (!cards[i].getAttribute('style')) cards[i].removeAttribute('style');
    }
  }

  function land(list) {
    var cards = list.children;
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.add(IN);
      cards[i].style.opacity = cards[i].__belloRestingOpacity || '1';
    }

    var last = cards[cards.length - 1];
    if (!last) return;

    // Read the real values rather than assuming the defaults, so a section that
    // overrides the timing still gets cleaned up at the right moment.
    var style = window.getComputedStyle(last);
    var seconds = function (value) {
      return parseFloat(String(value).split(',')[0]) || 0;
    };
    var total = (seconds(style.transitionDelay) + seconds(style.transitionDuration)) * 1000;

    setTimeout(function () {
      disarm(list);
    }, total + 60);
  }

  function arm(list) {
    if (list.__belloRevealArmed) return;
    list.__belloRevealArmed = true;

    // Someone who wants less motion gets the finished layout, never a hidden one.
    if (reduced && reduced.matches) return;

    // Index drives the stagger. Set before arming so the first paint after the
    // cards are hidden already carries each card's delay.
    var cards = list.children;
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.setProperty('--bello-reveal-index', i);

      // Remember where the card is meant to end up before hiding it. Lists that
      // dim their own rows must land back on that value, not on a flat 1.
      cards[i].__belloRestingOpacity = window.getComputedStyle(cards[i]).opacity;
      cards[i].style.opacity = '0';
    }

    list.classList.add(ARMED);

    if (!('IntersectionObserver' in window)) {
      land(list);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          land(entry.target);
        });
      },
      {
        // Starts once a sliver of the list has cleared the fold, so the first
        // card is already moving by the time the reader looks at it.
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.01,
      }
    );

    observer.observe(list);
  }

  function scan(root) {
    var lists = (root || document).querySelectorAll('[data-bello-reveal]');
    for (var i = 0; i < lists.length; i++) arm(lists[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // A section re-rendered in the theme editor arrives with its cards hidden
  // and no observer watching them.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
